import { useState } from 'react';
import { useCmsContent } from '../hooks/useCmsContent';
import { FALLBACK_MOANA } from '../components/moana-paye/moana-data';
import { MoanaHero } from '../components/moana-paye/MoanaHero';
import { MoanaArguments } from '../components/moana-paye/MoanaArguments';
import { MoanaModes } from '../components/moana-paye/MoanaModes';
import { MoanaPreview } from '../components/moana-paye/MoanaPreview';
import { MoanaTarifs } from '../components/moana-paye/MoanaTarifs';
import { MoanaPacks } from '../components/moana-paye/MoanaPacks';
import { MoanaSimulateur } from '../components/moana-paye/MoanaSimulateur';
import { MoanaFaq } from '../components/moana-paye/MoanaFaq';
import { MoanaContact } from '../components/moana-paye/MoanaContact';
import { MoanaSubscriptionModal } from '../components/moana-paye/MoanaSubscriptionModal';

export const MoanaPaye = () => {
  const cms = useCmsContent('moana-paye', FALLBACK_MOANA);
  const [showModal, setShowModal] = useState(false);
  const [modalPack, setModalPack] = useState('');

  const openPackModal = (packName) => {
    setModalPack(packName);
    setShowModal(true);
  };

  return (
    <div className="bg-[#F8FAFC]" data-testid="moana-paye-page">
      <MoanaHero cms={cms} />
      <MoanaArguments cms={cms} />
      <MoanaModes />
      <MoanaPreview />
      <MoanaTarifs />
      <MoanaPacks onOpenPackModal={openPackModal} />
      <MoanaSimulateur />
      <MoanaFaq cms={cms} />
      <MoanaContact />
      {showModal && (
        <MoanaSubscriptionModal
          packName={modalPack}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default MoanaPaye;
